var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nominee-categories" }, [
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.categoriesData, function(cat, index) {
        return _c("div", { staticClass: "col-4" }, [
          _c("div", { staticClass: "image-component-container mb-2" }, [
            _c("div", { staticClass: "image-component has-margin" }, [
              _vm.getIsEnabledCategory(cat.id)
                ? _c("img", {
                    attrs: { src: cat.image, alt: _vm.trans(cat.title) },
                    on: {
                      click: function($event) {
                        return _vm.selectCategory(cat.id)
                      }
                    }
                  })
                : _c("img", {
                    staticClass: "fadeImage",
                    attrs: { src: cat.image, alt: _vm.trans(cat.title) }
                  })
            ])
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }